export default __webpack_public_path__ + "static/media/tab3_2.5eb9fc04.png";